














import Vue from 'vue';
import BravadoBullLogo from '~/assets/svg/logo-bull__auth-modal.vue.svg';

export default Vue.extend({
  name: 'SignUpHeader',
  components: { BravadoBullLogo },
});
